"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILibraryWorkoutType = void 0;
var ILibraryWorkoutType;
(function (ILibraryWorkoutType) {
    ILibraryWorkoutType["Map"] = "map";
    ILibraryWorkoutType["Video"] = "video";
    ILibraryWorkoutType["Other"] = "other";
})(ILibraryWorkoutType || (exports.ILibraryWorkoutType = ILibraryWorkoutType = {}));
//# sourceMappingURL=library-workout-type.js.map